// Final CTA Section
export function FinalCTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-600 to-green-800 rounded-3xl" />

      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-500/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-green-700/20 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Sistema de gestão financeira{' '}
          <span className="text-green-200">inteligente e prático</span>
          <br />
          para o seu negócio
        </h2>

        <p className="text-xl md:text-2xl text-green-100 font-semibold mb-4">
          Simples, prático e rápido.
        </p>

        <p className="text-lg md:text-xl text-white mb-10 max-w-2xl mx-auto">
          Emissão de qualquer tipo de nota fiscal. Funciona em qualquer lugar do Brasil.
        </p>

        <button
          onClick={() => scrollToSection('pricing')}
          className="px-10 py-5 bg-green-700 hover:bg-green-800 text-white text-lg font-semibold rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
        >
          Comece agora
        </button>
      </div>
    </section>
  );
}
